import React from 'react';
import Icon from '../UI/Icon';
import useSwipeToClose from '../../hooks/useSwipeToClose';
import './ChapterSelector.css';

function ChapterSelector({ bookName, totalChapters, currentChapter, onSelectChapter, onClose }) {
  // Enable swipe-to-close on mobile
  const { ref: swipeRef } = useSwipeToClose(onClose);
  
  // Generate chapter numbers array
  const chapters = Array.from({ length: totalChapters }, (_, i) => i + 1);
  
  const handleChapterClick = (chapter) => {
    onSelectChapter(chapter);
    onClose();
  };
  
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="chapter-selector modal" ref={swipeRef} onClick={e => e.stopPropagation()}>
        <div className="modal-drag-handle" />
        <div className="modal-header">
          <h2 className="modal-title">{bookName}</h2>
          <button className="btn btn-ghost btn-icon" onClick={onClose}>
            <Icon name="close" size={20} />
          </button>
        </div>
        
        <div className="chapter-grid-container">
          <div className="chapter-grid">
            {chapters.map(chapter => (
              <button
                key={chapter}
                className={`chapter-block ${chapter === currentChapter ? 'active' : ''}`}
                onClick={() => handleChapterClick(chapter)}
              >
                {chapter}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChapterSelector;
